import { useSelector } from 'react-redux'
import { DocumentState } from '../../redux/types'
import { selectDocumentState } from '../../redux/docSlice'
import { htmlToString } from '../../helpers/utility'
import { useDocId } from '../../hooks/docID'
import { MdOutlineRadar } from 'react-icons/md'
import { useFeatureFlagVariantKey, usePostHog } from 'posthog-js/react'
import { FEATURE_FLAGS } from '../../hooks/featureFlags'
import CheckForAi from '../../Pages/Humanizer/check-for-ai'
import useWriteEssay from '../../hooks/useWriteEssay'
import { HumanizerIntensityLevel } from '../../Pages/Humanizer/constants'
import useIsPremium from '../../hooks/useIsPremium'

const Detector = () => {
	const docID = useDocId()
	const posthog = usePostHog()
	const documentState: DocumentState = useSelector((state) => selectDocumentState(state, docID))
	const humanizerV2 = useFeatureFlagVariantKey(FEATURE_FLAGS.HUMANIZER_V4)
	const sentenceHumanizerFF = useFeatureFlagVariantKey(FEATURE_FLAGS.SENTENCE_HUMANIZER)
	const { humanizeEssay } = useWriteEssay({ docID: docID })
	const showCompleteButton = useFeatureFlagVariantKey(FEATURE_FLAGS.SHOW_COMPLETE_BUTTON)
	const isPremium = useIsPremium()

	return (
		<CheckForAi
			text={htmlToString(documentState.content, humanizerV2 === 'test' || sentenceHumanizerFF === 'test')}
			onHumanizeClick={() => {
				humanizeEssay(
					documentState.content,
					documentState.drafts.findIndex((draft: any) => !!draft.selected),
					humanizerV2 === 'test' || sentenceHumanizerFF === 'test' ? HumanizerIntensityLevel.MEDIUM : undefined
				)
				posthog.capture('rehumanize-essay')
			}}
			context="writer"
			buttonChildren={
				<div className="flex items-center gap-2">
					{MdOutlineRadar({ className: 'text-sm hidden md:block' })}
					<div className="block md:hidden">AI Check</div>
					<div className="hidden md:block">Check for AI</div>
				</div>
			}
			humanized={isPremium && showCompleteButton === 'test'}
		/>
	)
}

export default Detector
